import { render, staticRenderFns } from "./SliderHome.vue?vue&type=template&id=6ca2c993&scoped=true&"
import script from "./SliderHome.vue?vue&type=script&lang=js&"
export * from "./SliderHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2c993",
  null
  
)

export default component.exports